<template>
  <div v-if="activeSession && newSession.id"
    :class="['session-r', { 'session-r-active': activeSession && this.newSession.id }]">
    <div>
      <div class="machine-setting-sec1" v-if="selectedMachine">
        <img v-if="!(exerciseStarted || exerciseStopped || showCountDown)" class="x-unselect-machine" width="20px"
          :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'" @click="unselectMachine()" />
        <span>{{ selectedMachine.name }}</span>
        <img class="machine-img" :src="fit20.storageBaseUrl + '/machine/' + selectedMachine.name + '.svg'">
        <img class="execute2" v-if="executeMachine && executeMachine[selectedMachine.id] == 1"
          :src="fit20.storageBaseUrl + '/machine-setting/execute1.svg'" />
        <img class="execute2" v-if="executeMachine && executeMachine[selectedMachine.id] == 2"
          :src="fit20.storageBaseUrl + '/machine-setting/execute2.svg'" />
      </div>
      <div v-if="selectedMachine" class="machine-setting-sec2">
        <div class="machine-settings-active" v-for="machineS, index in machineSetting[selectedMachine.id]"
          @click="editMachineSetting(selectedMachine.id, index, false, false, true)"><img
            v-if="machineS, machineS.image"
            :src="fit20.storageBaseUrl + '/machine-setting/' + machineS.image + '.svg'" />
          <span v-if="machineS && machineS.value">{{
            machineS.value }}</span>
          <div v-if="isDropdownOpenIndex == index && machineS.values" class="dropdown-container">
            <div class="dropdown-options">
              <div v-for="value in machineS.values"
                @click="editMachineSetting(selectedMachine.id, index, value, $event, true)" class="dropdown-option">
                {{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedMachine" class="machine-setting-sec3">
        <div><span class="orange machine-remark-title">{{
          '! - ' + $t('machine') }}</span><span> | </span>
          <div>
            <textarea class="unstyled-textarea" :id="'machine_remark' + member.id"
              v-model="machinesRemarks[selectedMachine.id]">
            </textarea>
          </div>
        </div>
      </div>
      <div v-if="selectedMachine" class="machine-setting-sec4 flex">
        <div class="machine-setting-time-sec"
          @click="(!exerciseStarted && isExerciseSelected) || (!exerciseStopped
            && !isExerciseSelected) && fit20.exercisesControl['tab' + (tabNum + 2)].length < 1 ? showStartBtn(true, false) : ''">
          <span class="machine-setting-time">{{
            selectedExercise.duration ? secondsToTime(selectedExercise.duration).split(":")[0] : '..' }}</span>
          <span class="machine-setting-time-colin">:</span>
          <span class="machine-setting-time">{{
            selectedExercise.duration ? secondsToTime(selectedExercise.duration).split(":")[1] : '..' }}</span>
        </div>
        <div @click="changeExerciseWeight()" class="dropdown-options-weight">
          <span class="machine-setting-weight">{{ selectedExercise.weight }}</span>
          <div v-if="isWeightDropdownOpen && selectedMachine.weights" class="dropdown-container">
            <div class="dropdown-options dropdown-options-weight">
              <div v-for="value in selectedMachine.weights.split(' ')"
                :id="value == selectedExercise.weight ? 'selected_weight' + member.id : ''"
                @click="changeExerciseWeight(selectedMachine.id, value)"
                :class="['dropdown-option', { 'selected-weight': value == selectedExercise.weight }]">
                {{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedMachine">
        <div v-if="selectedMachine" class="machine-setting-sec5">
          <div><span class="orange machine-remark-title">{{
            '! - ' + $t('exercise') }}</span><span> | </span>
            <div>
              <textarea class="unstyled-textarea" :id="'exercise_remark' + member.id"
                v-model="selectedExercise.remark"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedMachine" class="machine-setting-sec6 flex">
        <div>
          <img v-if="repCount <= 2" :src="fit20.storageBaseUrl + '/static/icons/10light-grey.svg'" />
          <img @click="stationary()" v-if="repCount > 2 && !showStationary"
            :src="fit20.storageBaseUrl + '/static/icons/10grey.svg'" />
          <img v-if="showStationary" :src="fit20.storageBaseUrl + '/static/icons/10green.svg'" />
        </div>
        <div>
          <img v-if="!exerciseStarted && !exerciseStopped"
            :src="fit20.storageBaseUrl + '/static/icons/stop-light-grey.svg'" />
          <img @click="stopExercise()" v-if="exerciseStarted"
            :src="fit20.storageBaseUrl + '/static/icons/stop-grey.svg'" />
          <img @click="unselectExercise(true)" v-if="exerciseStopped"
            :src="fit20.storageBaseUrl + '/static/icons/stop-green.svg'" />
        </div>
        <div>
          <img v-if="(repCount <= 2 || newSession.exercises.length <= 2) && !lastExercise"
            :src="fit20.storageBaseUrl + '/static/icons/star-light-grey.svg'" />
          <img @click="setLastExercise()" v-if="repCount > 2 && newSession.exercises.length > 2 && !lastExercise"
            :src="fit20.storageBaseUrl + '/static/icons/star-grey.svg'" />
          <img @click="setLastExercise()" v-if="lastExercise"
            :src="fit20.storageBaseUrl + '/static/icons/star-green.svg'" />
        </div>
        <div @click="handleWeightChange()">
          <img v-if="!selectedExercise.weightChange" :src="fit20.storageBaseUrl + '/static/icons/up-down-gray.svg'" />
          <img v-if="selectedExercise.weightChange" :src="fit20.storageBaseUrl + '/static/icons/up-down-green.svg'" />
        </div>
      </div>
    </div>
    <!-- start start btn popup -->
    <div class="popup-overlay" v-if="showStartBtnPopup">
      <div class="">
        <div>
          <br>
          <div class="start-exercise-popup animated zoomIn">
            <img
              v-if="(!exerciseStarted && isExerciseSelected && !exerciseStopped && fit20.exercisesControl['tab' + (tabNum + 2)].length < 1)"
              width="75" :src="fit20.storageBaseUrl + '/static/icons/play.png'" @click="showStartBtn(false, true)" />
            <img width="75" :src="fit20.storageBaseUrl + '/static/icons/edit.svg'"
              @click="showStartBtn(false, false, true)" />
            <img width="75" :src="fit20.storageBaseUrl + '/static/icons/x.png'" @click="showStartBtn(false, false)" />
          </div>
          <br>
        </div>
      </div>
    </div>
    <!-- start edit time popup -->
    <div class="popup-overlay" v-if="editTimePopup">
      <div class="edit-time">
        <div>
          <br>
          <div class="start-exercise-popup animated zoomIn">
            <div class="edit-time-sec">
              <input type="number" @input="setMin" min="0"
                :value="selectedExercise.duration ? secondsToTime(selectedExercise.duration).split(':')[0] : 0" />
              <div> : </div>
              <input type="number" @input="setSec" min="0"
                :value="selectedExercise.duration ? secondsToTime(selectedExercise.duration).split(':')[1] : 0" />
            </div>
            <div class="edit-time-btn-sec">
              <img width="70" :src="fit20.storageBaseUrl + '/static/icons/save.png'" @click="saveTime(true)" />
              <img width="70" :src="fit20.storageBaseUrl + '/static/icons/x.png'" @click="saveTime(false)" />
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SessionR',
  props: ["fit20", "member", "activeSession", "newSession", "selectedMachine", "executeMachine", "machineSetting",
    "isDropdownOpenIndex", "machinesRemarks", "selectedExercise", "setMachineExecute", "editMachineSetting",
    "isWeightDropdownOpen", "unselectExercise", "changeExerciseWeight", "exerciseChangeValues",
    'exerciseStarted', 'showStartBtn', "showStartBtnPopup", "stopExercise", 'exerciseStopped',
    "isExerciseSelected", "tabNum", "saveTime", "editTimePopup", "setMin", "setSec", "repCount", "lastExercise",
    "setLastExercise", "showStationary", "stationary", "unselectMachine", "showCountDown"],
  data() {
    return {


    }
  },
  methods: {
    secondsToTime: function (seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;

      // Use template literals to format the time
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },
    handleWeightChange: function () {
      if (this.selectedExercise.weightChange) {
        let index = this.exerciseChangeValues.findIndex(item => item == this.selectedExercise.weightChange);
        if (index != -1) {
          if (index < 3) {
            this.selectedExercise.weightChange = this.exerciseChangeValues[index + 1];
          } else { this.selectedExercise.weightChange = 'MORE'; }
        } else {
          this.selectedExercise.weightChange = 'MORE';
        }
      }
      else {
        this.selectedExercise.weightChange = 'MORE';
      }
    },

  },
};
</script>
<style>
.x-unselect-machine {
  position: absolute;
  left: 20px;
}

/*  some classes can be in Session component */
.start-exercise-popup {
  background-color: white;
  padding: 30px;
  display: flex;
  width: 420px;
  justify-content: space-between;
  border-radius: 10px;
}

.edit-time-sec {
  display: flex;
  width: 55%;
  justify-items: center;
  color: var(--fit20-blue);
  font-size: 23px;
  font-family: 'VAG light', 'Courier New', Courier, monospace;
}



.edit-time-sec input:focus {
  outline: none;
}

.edit-time-btn-sec {
  width: 45%;
  display: flex;
  justify-content: space-between;
}

.edit-time-sec input {
  width: 60px;
  border: solid 1px var(--fit20-blue);
  border-radius: 5px;
  padding: 5px;
  color: var(--fit20-blue);
  font-size: 23px;
  font-family: 'VAG light', 'Courier New', Courier, monospace;
}



.edit-time-sec div {
  padding: 10px 5px;
}

.edit-time-sec input:focus {
  text-decoration: none;
}

.selected-weight {
  background-color: var(--fit20-lighter-blue);
}

.dropdown-options-weight {
  min-width: 60px;
  color: black;
}

.session-r textarea {
  width: 100%;
}
</style>
